import { useDashboardAddOnUrl } from "@/utils/redirects";
import { FaroText } from "@faro-lotv/flat-ui";
import { Link } from "@mui/material";
import type { JSX } from "react";

/** @returns A short message with a link to the Add On Gallery */
export function PointCloudAddOnRequiredMessage(): JSX.Element {
  const addOnUrl = useDashboardAddOnUrl();

  return (
    <FaroText variant="bodyL" dark>
      <Link href={addOnUrl}>Point cloud management add-on</Link> required
    </FaroText>
  );
}
